import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { OnboardingBrowserRuntimeImpl } from '../../common/services/impls/onboarding-browser-runtime';
import type { FtoProOnboardingRuntime } from '../fto-pro-onboarding-runtime';

/** FTO Pro 首次引导的浏览器 runtime，复用公共 DOM、Driver、存储和定时器能力。 */
@injectable()
export class FtoProOnboardingRuntimeImpl
    extends OnboardingBrowserRuntimeImpl
    implements FtoProOnboardingRuntime {
    constructor(
        /** 提供当前登录账号信息。 */
        @inject(HeaderServiceProxy)
        private readonly _headerServiceProxy: HeaderServiceProxy,
    ) {
        super();
    }

    /** 获取用于隔离首次展示状态的登录账号 ID。 */
    getIdentityId(): Promise<string> {
        return Promise.resolve(
            this._headerServiceProxy.headerService.account?._info.account_id ?? '',
        );
    }

    /** 查询当前用户登录状态。 */
    isUserLogin(): Promise<boolean> {
        return isUserLogin();
    }
}
